var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "lg": "12"
    }
  }, [_c('iq-card', {
    attrs: {
      "body-class": "p-0"
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function fn() {
        return [_c('div', {
          staticClass: "iq-edit-list"
        }, [_c('tab-nav', {
          staticClass: "iq-edit-profile d-flex",
          attrs: {
            "pills": true
          }
        }, [_c('tab-nav-items', {
          staticClass: "col-md-4 p-0",
          attrs: {
            "active": true,
            "href": "#goodsSetup",
            "title": "Goods Setup in Fleets"
          }
        }), _c('tab-nav-items', {
          staticClass: "col-md-4 p-0",
          attrs: {
            "active": false,
            "href": "#goods",
            "title": "Goods"
          }
        }), _c('tab-nav-items', {
          staticClass: "col-md-4 p-0",
          attrs: {
            "active": false,
            "href": "#categoryUnits",
            "title": "Category & Units"
          }
        })], 1)], 1)];
      },
      proxy: true
    }])
  })], 1)], 1), _c('div', {
    staticClass: "tab-content",
    attrs: {
      "id": "pills-tabContent-2"
    }
  }, [_c('tab-content-item', {
    attrs: {
      "active": true,
      "id": "goodsSetup"
    }
  }, [_c('ComponentGoodsSetup')], 1), _c('tab-content-item', {
    attrs: {
      "active": false,
      "id": "goods"
    }
  }, [_c('ComponentGoods')], 1), _c('tab-content-item', {
    attrs: {
      "active": false,
      "id": "categoryUnits"
    }
  }, [_c('ComponentCategoryUnits')], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }